document.addEventListener('alpine:init', () => {
  Alpine.data('xFlexAccordion', (config) => ({
    open: config.openOnLoad,

    init() {
      const id = config.anchorId;
      const title = config.title;

      if (id && title && config.showAsLink) {
        window.NAAccordionItems = window.NAAccordionItems || [];
        window.NAAccordionItems.push({ id, title, el: this.$el });
        document.dispatchEvent(new CustomEvent('flex-accordion:register', { detail: { id, title } }));
      }

      const tryOpen = () => {
        if (id && window.location.hash === '#' + id) {
          const det = this.$el.querySelector('details');

          if (det) det.open = true;

          this.$nextTick(() => {
            const accNavBar = document.querySelector('.product-acc-nav__bar.is-sticky');
            let topOffset;

            if (accNavBar) {
              topOffset = Math.round(accNavBar.getBoundingClientRect().bottom) + 8;
            } else {
              const headerEl = document.querySelector('.section-header')
                || document.querySelector('#x-header-container')
                || document.querySelector('.shopify-section-header-sticky header');
              topOffset = headerEl ? Math.max(0, Math.round(headerEl.getBoundingClientRect().bottom)) + 8 : 88;
            }
            
            const targetEl = this.$el.querySelector('details > summary') || this.$el;
            window.scrollTo({
              top: targetEl.getBoundingClientRect().top + window.scrollY - topOffset,
              behavior: 'smooth'
            });
          });
        }
      };

      tryOpen();
      window.addEventListener('hashchange', tryOpen);
    }
  }));
});
